import { EnhancedTrackInfo } from "./EnhancedTrackInfo";
import { PlayerControls } from "./PlayerControls";
import { PlayerActionControls } from "./PlayerActionControls";
import { Track } from "@/types";

interface PlayerExpandedDesktopProps {
  currentTrack: Track;
  isPlaying: boolean;
  liked: boolean;
  sponsorName?: string | null;
  sponsorUsername?: string | null;
  sponsorAvatar?: string | null;
  volume: number;
  currentTime: number;
  onToggleLike: () => void;
  onTogglePlayPause: () => void;
  onVolumeChange: (value: number[]) => void;
  onSeek: (value: number[]) => void;
  formatTime: (timeInSeconds: number) => string;
}

export function PlayerExpandedDesktop({
  currentTrack,
  isPlaying,
  liked,
  sponsorName,
  sponsorUsername,
  sponsorAvatar,
  volume,
  currentTime,
  onToggleLike,
  onTogglePlayPause,
  onVolumeChange,
  onSeek,
  formatTime,
}: PlayerExpandedDesktopProps) {
  return (
    <div className="flex-1 w-full max-w-7xl mx-auto grid grid-cols-1 xl:grid-cols-2 gap-8">
      {/* Track Details Section */}
      <div className="space-y-4 md:space-y-6">
        <EnhancedTrackInfo
          track={currentTrack}
          sponsorName={sponsorName}
          sponsorUsername={sponsorUsername}
          sponsorAvatar={sponsorAvatar}
        />
      </div>

      {/* Player Controls Section */}
      <div className="flex flex-col justify-center">
        <div className="w-full mx-auto max-w-lg">
          <PlayerControls
            isPlaying={isPlaying}
            togglePlayPause={onTogglePlayPause}
            currentTime={currentTime}
            duration={currentTrack.duration}
            onSeek={onSeek}
            formatTime={formatTime}
          />
        </div>

        {/* Enhanced Controls Section */}
        <PlayerActionControls volume={volume} onVolumeChange={onVolumeChange} />
      </div>
    </div>
  );
}
